import $ from '../core/Dom';
import Components from '../core/Components';
import request from '../core/request';
import Dispatch from '../core/Dispatch';

import { PRODUCT_LISTINGS_UPDATED } from '../lib/events';

export default (el, props) => {
    const $el = $(el);
    const $input = $el.find('input[name="q"]');
    const $result = $el.find('[data-result-content]');

    const { baseUrl } = props;

    const parseData = data => {
        const $data = $(data);
        $result.empty().append($data.find('[data-result-content]'));
        //$spinner.addClass('hidden');
        Components.init($result);
        Dispatch.emit(PRODUCT_LISTINGS_UPDATED, { wrapper: $result });
        //gsap.to($content.nodes, { duration: 0.2, opacity: 1 });
    };
    
    const doSearch = () => {
        request
            .get(`${baseUrl}`)
            .query({ q: $input.val() })
            .then(res => {
                if (res.statusCode === 200) {
                    parseData(res.text);
                } else {
                    // todo : feilmelding
                }
            });
    };

    const init = () => {
        $el.on('submit', e => {
            e.preventDefault();
            
            doSearch();
        });
        
        $el.on('click', '[data-quick-search-term]', e => {
            e.preventDefault();
            const $trigger = $(e.triggerTarget);
            const term = $trigger.data('quick-search-term');
            $input.val(term);
            doSearch();
        });
    };

    const destroy = () => {
        $el.off('submit');
    };

    return {
        init,
        destroy
    };
};
